import { createSelector } from "reselect";
import alarms from '../constants/alarms';

const plcStatusWord1Id = 211;
const alarmBitLocation = 8;

const systemAlarmOrFaultPresentRef = (alarms.status.find(({ id }) => id === plcStatusWord1Id) || { decode: {} }).decode[alarmBitLocation];

const status = state => state.status;

const getPlcStatusWord1Alarm = (status) => {
  const plcStatusWord1 = status.find(({ id }) => id === plcStatusWord1Id);

  return plcStatusWord1 &&
    plcStatusWord1
      .values
      .find(({ title }) => title === systemAlarmOrFaultPresentRef)
      .value;
};

export default createSelector(
  status,
  getPlcStatusWord1Alarm
);



// WEBPACK FOOTER //
// ./src/selectors/get_plc_status_word_1_alarm.js